import { Code2, WandSparkles } from 'lucide-react'
import { useStudioLocale } from '@/i18n'
import { useStudioStore } from '@/store/studio-store'
import type { StudioPersona } from '@/store/ide-v2-slice'
import { COOGO_IDE_CHROME_COPY } from '../coogo-ide-chrome-copy'

const OPTIONS: Array<{ id: StudioPersona; Icon: typeof WandSparkles }> = [
  { id: 'creator', Icon: WandSparkles },
  { id: 'developer', Icon: Code2 },
]

export function PersonaSwitcher() {
  const { locale } = useStudioLocale()
  const copy = COOGO_IDE_CHROME_COPY[locale]
  const persona = useStudioStore((s) => s.studioPersona)
  const setPersona = useStudioStore((s) => s.setStudioPersona)

  return (
    <div
      className="flex items-center rounded-md border border-border bg-muted/40 p-0.5"
      data-testid="persona-switcher"
      aria-label={copy.persona.toolVisibility}
    >
      {OPTIONS.map(({ id, Icon }) => {
        const active = persona === id
        const label = id === 'creator' ? copy.persona.essentials : copy.persona.allTools
        return (
          <button
            key={id}
            type="button"
            // Slice 6 §3 measured these buttons as icon-only with no test id
            // and localized accessible names, so every locator for them died
            // on a copy change. A stable id per option means a gate can fail
            // for the reason it exists instead of for a translation.
            data-testid={`persona-option-${id}`}
            aria-label={label}
            title={label}
            aria-pressed={active}
            onClick={() => setPersona(id)}
            className={`inline-flex h-7 items-center gap-1.5 rounded px-2 text-[11px] font-medium transition-colors ${
              active
                ? 'bg-card text-foreground shadow-sm'
                : 'text-muted-foreground hover:text-foreground'
            }`}
          >
            <Icon size={13} strokeWidth={1.8} aria-hidden />
          </button>
        )
      })}
    </div>
  )
}
